// Global JavaScript for HANA Beauty Theme

function updateEditorialCategoriesState(section, swiper) {
  section.classList.toggle('editorial-categories--locked', swiper.isLocked);
  section.classList.toggle('is-at-start', swiper.isBeginning);
  section.classList.toggle('is-at-end', swiper.isEnd);
}

function initEditorialCategoriesCarousels(context = document) {
  if (typeof Swiper === 'undefined' || !context || !context.querySelectorAll) {
    return;
  }

  const sections = context.matches && context.matches('[data-editorial-categories]')
    ? [context]
    : context.querySelectorAll('[data-editorial-categories]');

  sections.forEach(section => {
    const slider = section.querySelector('[data-editorial-categories-swiper]');

    if (!slider) {
      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const desktopColumns = Number(section.dataset.desktopColumns || 4);
    const nextButton = section.querySelector('.editorial-categories__button--next');
    const prevButton = section.querySelector('.editorial-categories__button--prev');
    const pagination = section.querySelector('.editorial-categories__pagination');
    const desktopSlides = desktopColumns === 5 ? 5.18 : 4.18;

    const swiperOptions = {
      slidesPerView: 1.18,
      spaceBetween: 14,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      breakpoints: {
        768: {
          slidesPerView: 2.18,
          spaceBetween: 18
        },
        990: {
          slidesPerView: desktopSlides,
          spaceBetween: desktopColumns === 5 ? 18 : 20
        }
      },
      on: {
        init(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        breakpoint(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        lock(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        unlock(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        resize(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        reachBeginning(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        reachEnd(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        fromEdge(swiper) {
          updateEditorialCategoriesState(section, swiper);
        },
        slideChange(swiper) {
          updateEditorialCategoriesState(section, swiper);
        }
      }
    };

    if (pagination) {
      swiperOptions.pagination = {
        el: pagination,
        type: 'progressbar'
      };
    }

    if (nextButton && prevButton) {
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }

    new Swiper(slider, swiperOptions);
  });
}

function updateTestimonialShowcaseState(section, swiper) {
  section.classList.toggle('testimonial-showcase--locked', swiper.isLocked || swiper.slides.length <= 1);
}

function initTestimonialShowcases(context = document) {
  if (typeof Swiper === 'undefined' || !context || !context.querySelectorAll) {
    return;
  }

  const sections = context.matches && context.matches('[data-testimonial-showcase]')
    ? [context]
    : context.querySelectorAll('[data-testimonial-showcase]');

  sections.forEach(section => {
    const slider = section.querySelector('[data-testimonial-swiper]');

    if (!slider) {
      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const nextButton = section.querySelector('.testimonials-showcase__button--next');
    const prevButton = section.querySelector('.testimonials-showcase__button--prev');
    const pagination = section.querySelector('.testimonials-showcase__pagination');
    const autoplayEnabled = section.dataset.testimonialAutoplay === 'true';
    const autoplayDelay = Number(section.dataset.testimonialDelay || 5000);

    const swiperOptions = {
      initialSlide: 0,
      slidesPerView: 1.06,
      spaceBetween: 16,
      speed: 850,
      centeredSlides: false,
      centerInsufficientSlides: false,
      grabCursor: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      loop: false,
      rewind: slideCount > 1,
      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 1.56,
          spaceBetween: 26
        }
      },
      on: {
        init(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        },
        breakpoint(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        },
        lock(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        },
        unlock(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        },
        resize(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        },
        update(swiper) {
          updateTestimonialShowcaseState(section, swiper);
        }
      }
    };

    if (autoplayEnabled && slideCount > 1) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    if (pagination) {
      swiperOptions.pagination = {
        el: pagination,
        clickable: true
      };
    }

    if (nextButton && prevButton) {
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }

    new Swiper(slider, swiperOptions);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu and search are handled in header.liquid

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Product variant selection
  const variantOptions = document.querySelectorAll('.variant-option');
  variantOptions.forEach(option => {
    option.addEventListener('click', function() {
      const optionName = this.dataset.optionName;
      const optionValue = this.dataset.optionValue;

      // Update selected display
      const selectedDisplay = document.getElementById('selected-' + optionName);
      if (selectedDisplay) {
        selectedDisplay.textContent = optionValue;
      }

      // Update button states
      document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(btn => {
        btn.classList.remove('border-primary', 'bg-primary', 'text-cream');
        btn.classList.add('border-primary/20');
      });
      this.classList.remove('border-primary/20');
      this.classList.add('border-primary', 'bg-primary', 'text-cream');
    });
  });

  // Quantity controls
  const quantityDecrease = document.querySelector('.quantity-decrease');
  const quantityIncrease = document.querySelector('.quantity-increase');
  const quantityInput = document.getElementById('Quantity');

  if (quantityDecrease && quantityInput) {
    quantityDecrease.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }

  if (quantityIncrease && quantityInput) {
    quantityIncrease.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }

  // Product image gallery
  function changeProductImage(imageUrl) {
    const productImage = document.getElementById('ProductImage');
    if (productImage) {
      productImage.src = imageUrl;
    }
  }

  // Make changeProductImage globally available
  window.changeProductImage = changeProductImage;

  initEditorialCategoriesCarousels(document);
  initTestimonialShowcases(document);
});

// ============================================
// Cart Count Update Functions
// ============================================

// Update cart count in header
function updateCartCount(count) {
  const cartCountElements = document.querySelectorAll('[data-cart-count]');

  cartCountElements.forEach(element => {
    element.textContent = count;

    if (count > 0) {
      element.classList.remove('hidden');
      // Add a little animation
      element.style.transform = 'scale(1.2)';
      setTimeout(() => {
        element.style.transform = 'scale(1)';
      }, 150);
    } else {
      element.classList.add('hidden');
    }
  });
}

// Fetch cart and update count
function refreshCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartCount(cart.item_count);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Add to cart with AJAX
function addToCart(formData, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(data => {
      // Refresh the cart count
      refreshCartCount();

      // Show success feedback
      showCartNotification('Produto adicionado ao carrinho!');

      // Call callback if provided
      if (typeof callback === 'function') {
        callback(data);
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showCartNotification('Erro ao adicionar produto', true);
    });
}

// Show notification
function showCartNotification(message, isError = false) {
  // Remove existing notification
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  // Create notification
  const notification = document.createElement('div');
  notification.className = 'cart-notification';
  notification.innerHTML = `
    <div class="cart-notification-content ${isError ? 'cart-notification--error' : ''}">
      ${isError ? '' : '<svg class="cart-notification-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>'}
      <span>${message}</span>
    </div>
  `;

  document.body.appendChild(notification);

  // Trigger animation
  requestAnimationFrame(() => {
    notification.classList.add('is-visible');
  });

  // Remove after delay
  setTimeout(() => {
    notification.classList.remove('is-visible');
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

// Make functions globally available
window.updateCartCount = updateCartCount;
window.refreshCartCount = refreshCartCount;
window.addToCart = addToCart;
window.showCartNotification = showCartNotification;

// Listen for Shopify cart events
document.addEventListener('cart:updated', refreshCartCount);

document.addEventListener('shopify:section:load', function(event) {
  initEditorialCategoriesCarousels(event.target);
  initTestimonialShowcases(event.target);
});

// Intercept form submissions for add to cart
document.addEventListener('submit', function(e) {
  const form = e.target;

  // Check if it's an add to cart form
  if (form.action && form.action.includes('/cart/add')) {
    e.preventDefault();

    const formData = new FormData(form);
    const submitButton = form.querySelector('[type="submit"]');

    // Disable button during submission
    if (submitButton) {
      submitButton.disabled = true;
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Adicionando...';

      addToCart(formData, () => {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      });
    } else {
      addToCart(formData);
    }
  }
});
